import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateProjectHasDietTypeDto {
  @Expose()
  @Transform(({ value }) => toCents(value))
  cost: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  accommodationExpenses?: number;
}
